<template>
  <div>
    <div v-if="request" class="maintenance__detail-wrap">
      <div class="maintenance__breadcrumb">
        <router-link
          :to="
            `/maintenance?status=${request.status}&page=${getPages}&currentPage=${curPage}`
          "
          >{{ request.status | capitalize }}</router-link
        >
        <svgicon icon="drop-down"></svgicon>
        <span>View Request Details</span>
      </div>

      <div class="maintenance__top" style="margin-bottom:32px;max-width:895px;">
        <p class="maintenance__title">
          View Maintenance Request
          <span
            class="maintenance__status align-middle"
            :class="[
              { completed: request.status == 'completed' },
              { pending: request.status == 'pending' },
              { review: request.status == 'in review' },
              { review: request.status == 'pending decline' },
              { assessing: request.status == 'assessing' },
              { follow: request.status == 'follow up' },
              { declined: request.status == 'declined' },
              { contested: request.status == 'contested' },
              { escalated: request.status == 'escalated' },
              { closed: request.status == 'closed' },
              { reopened: request.status == 'reopened' }
            ]"
            >{{ request.status }}</span
          >
          <small class="maintenance__ticket-id"
            ><strong>Ticket Id:</strong> {{ request.ticketId }}</small
          >
        </p>

        <div class="d-flex">
          <div
            class="maintenance__detail-action"
            style="margin-top: 0px"
            v-if="request.status === 'pending decline'"
          >
            <button
              class="outline_btn outline_btn-green"
              type="button"
              @click="toggleApproveRequestToDeclineModal"
            >
              Approve
            </button>
            <button
              class="c_btn c_btn-red"
              @click="toggleRejectRequestToDeclineModal"
              type="button"
            >
              Reject
            </button>
          </div>

          <!-- Nudge Member -->
          <button
            class="outline_btn outline_btn-blue"
            v-if="
              (request.status === 'completed' && !requestRating) ||
                (request.status === 'reopened' &&
                  requestAppointments.some(
                    el => el.createdBy === 'admin' && el.reopened
                  ))
            "
            @click="toggleNudgeModal('member')"
          >
            Nudge member
          </button>

          <!-- Nudge Host -->
          <button
            class="outline_btn outline_btn-blue"
            @click="toggleNudgeModal('host')"
            v-if="
              request.status === 'assessing' ||
                request.status === 'follow up' ||
                (request.status === 'reopened' &&
                  requestAppointments.some(
                    el => el.createdBy === 'member' && el.reopened
                  ))
            "
          >
            Nudge Host
          </button>

          <!-- Update Ticket -->
          <div
            class="maintenance__dropdown ml-4"
            v-if="
              request.status === 'assessing' ||
                request.status === 'follow up' ||
                (requestReopen &&
                  requestReopen.artisanName &&
                  request.status !== 'completed' &&
                  request.status !== 'closed' &&
                  request.status !== 'escalated') ||
                (request.status === 'reopened' &&
                  requestAppointments.some(
                    el => el.createdBy === 'admin' && el.reopened
                  ))
            "
          >
            <button
              type="button"
              class="c_btn c_btn-blue"
              @click="
                () => {
                  updateDropdown = !updateDropdown;
                }
              "
            >
              Update ticket
            </button>
            <div
              class="maintenance__dropdown-content mt-2"
              v-if="updateDropdown"
              v-on-clickaway="
                () => {
                  updateDropdown = false;
                }
              "
            >
              <div
                class="maintenance__dropdown-item"
                @click="toggleFollowupModal"
                v-if="
                  !requestAppointments.some(
                    el => el.createdBy === 'admin' && el.reopened
                  )
                "
              >
                Follow up
              </div>
              <!-- <div
                class="maintenance__dropdown-item"
                @click="toggleFollowupModal"  v-else
              >
                Escalate to Admin
              </div> -->
              <div
                class="maintenance__dropdown-item"
                @click="toggleCompleteModal"
              >
                Complete
              </div>
            </div>
          </div>

          <!-- Comment and followup on escalation -->
          <div class="maintenance__detail-action" style="margin-top: 0px">
            <button
              class="c_btn c_btn-blue"
              @click="toggleCommentModal"
              type="button"
              v-if="
                request.status === 'escalated' ||
                  request.status === 'closed' ||
                  request.status === 'completed'
              "
            >
              Comment
            </button>
            <!-- <button
              class="outline_btn outline_btn-blue"
              @click="toggleFollowupOnEscModal"
              type="button"
              v-if="request.status === 'escalated'"
            >
              Follow Up
            </button> -->
            <button
              class="outline_btn outline_btn-blue"
              @click="toggleReopenModal"
              type="button"
              v-if="request.status === 'closed' && !requestRating"
            >
              Reopen request
            </button>
          </div>
        </div>
      </div>

      <div class="maintenance__detail">
        <div class="vas">
          <div class="accordion vas__desktop" role="tablist">
            <!-- Host's Pending Decline -->
            <b-card no-body v-if="request.status === 'pending decline'">
              <b-card-header header-tag="header" role="tab">
                <b-button
                  block
                  v-b-toggle="'accordion-' + request.id"
                  variant="info"
                  style="background-color: #fff"
                >
                  Host Decline Response
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'accordion-' + request.id"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <p class="maintenance__detail-title">Reason for Decline</p>
                  <p class="maintenance__detail-item">
                    {{ request.description }}
                  </p>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- escalated -->
            <b-card
              no-body
              v-for="(escalate, index) in requestEscalates"
              :key="index + escalate.maintenanceId"
            >
              <b-card-header header-tag="header" role="tab">
                <b-button
                  block
                  v-b-toggle="'accordion-escalate' + index"
                  variant="info"
                  style="background-color: #fff"
                >
                  Escalated by {{ escalate.escalateBy | capitalize }} to You
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'accordion-escalate' + index"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <p class="maintenance__detail-title">
                    Reason for escalation
                  </p>
                  <p class="maintenance__detail-item">
                    {{ escalate.reason }}
                  </p>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- ratings after reopen -->
            <b-card
              no-body
              v-if="
                (requestRating && requestReopen) ||
                  (requestRating &&
                    requestUpdates.some(update => update.afterReopen))
              "
            >
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.ratings variant="info">
                  <span>
                    Your feedback
                  </span>
                  <div
                    class="d-flex"
                    v-if="
                      request.status === 'completed' ||
                        request.status === 'closed'
                    "
                  >
                    <span class="mr-5">
                      Request completed
                    </span>
                    <svgicon
                      icon="check-circle"
                      style="fill:transparent;stroke:#62E2AA;width:17px"
                    ></svgicon>
                  </div>
                  <div class="home__faq-icon-wrap" v-else>
                    <svgicon
                      icon="drop-down"
                      class="home__faq-icon"
                      style="stroke:#111827"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="ratings"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body style="padding-right:24px">
                  <div class="d-flex">
                    <div class="maintenance__detail-row">
                      <p class="maintenance__detail-title">Rating</p>
                      <p class="maintenance__detail-item">
                        {{
                          Number(requestRating.rating) &lt;= 2
                            ? "Poor"
                            : Number(requestRating.rating) &lt;= 4
                            ? "Good"
                            : "Delighted"
                        }}
                      </p>
                    </div>
                    <div style="width:fit-content;margin-left:90px">
                      <star-rating
                        :rating="Number(requestRating.rating)"
                        :star-size="32"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#C4C4C4"
                        :active-color="['#CE574D', '#CE574D', '#62E2AA']"
                      ></star-rating>
                    </div>
                  </div>

                  <div>
                    <p class="maintenance__detail-title">Comment</p>
                    <p class="maintenance__detail-item">
                      {{ requestRating.feedback }}
                    </p>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- update afterReopen -->
            <b-card
              no-body
              v-for="(update, index) in requestUpdates.filter(
                update => update.afterReopen
              )"
              :key="index + update.id"
            >
              <b-card-header header-tag="header" role="tab">
                <b-button
                  block
                  v-b-toggle="'accordion-' + update.id"
                  variant="info"
                >
                  {{
                    update.withAppointment
                      ? `${firstLetterToUpperCase(
                          update.updateBy
                        )} Follow Up Response`
                      : (request.status === "completed" ||
                          request.status === "closed") &&
                        requestUpdates.length > 1 &&
                        index === 0
                      ? `Request completed by ${firstLetterToUpperCase(
                          update.updateBy
                        )}`
                      : "Assessment Update"
                  }}
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'accordion-' + update.id"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div v-if="update.withAppointment">
                    <div class="maintenance__detail-row">
                      <p class="maintenance__detail-title">
                        Follow Up Comment
                      </p>
                      <p class="maintenance__detail-item">
                        {{ update.description }}
                      </p>
                    </div>
                    <div
                      class="maintenance__detail-row mb-0"
                      v-if="
                        requestAppointments.filter(el => !el.used).length !==
                          0 && !update.appointmentId
                      "
                    >
                      <p class="maintenance__detail-title">
                        Follow up Date and Time
                      </p>
                      <p
                        class="maintenance__detail-item"
                        v-for="(appointment,
                        index) in requestAppointments.filter(el => !el.used)"
                        :key="index"
                      >
                        <span style="margin-right:41px">{{
                          appointment.date | formatDate
                        }}</span>
                        <span>{{ appointment.time | formatTimeHour }}</span>
                      </p>
                    </div>

                    <div v-else class="d-flex flex-wrap">
                      <div class="maintenance__detail-top-col">
                        <p class="maintenance__detail-title">
                          Follow up Date and Time
                        </p>
                        <p class="maintenance__detail-item">
                          <span style="margin-right:41px">{{
                            requestAppointments.find(
                              el => el.id === update.appointmentId
                            ).date | formatDate
                          }}</span>
                          <span>{{
                            requestAppointments.find(
                              el => el.id === update.appointmentId
                            ).time | formatTimeHour
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <p class="maintenance__detail-title">
                      Situation Update Comment
                    </p>
                    <p class="maintenance__detail-item">
                      {{ update.description }}
                    </p>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- admin reopened -->
            <b-card
              no-body
              v-if="
                requestAppointments.some(
                  el => el.createdBy === 'admin' && el.reopened
                )
              "
            >
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.adminReopened variant="info">
                  You reopened this request
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="adminReopened"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div>
                    <div class="maintenance__detail-top mb-0">
                      <div class="maintenance__detail-top-col">
                        <div
                          class="maintenance__detail-row mb-0"
                          v-if="
                            requestAppointments.filter(
                              el =>
                                el.createdBy === 'admin' &&
                                el.reopened &&
                                !el.used
                            ).length !== 0
                          "
                        >
                          <p class="maintenance__detail-title">
                            Reopened appointment Date and Time
                          </p>
                          <p
                            class="maintenance__detail-item"
                            v-for="(appointment,
                            index) in requestAppointments.filter(
                              el =>
                                el.createdBy === 'admin' &&
                                el.reopened &&
                                !el.used
                            )"
                            :key="index"
                          >
                            <span style="margin-right:41px">{{
                              appointment.date | formatDate
                            }}</span>
                            <span>{{ appointment.time | formatTimeHour }}</span>
                          </p>
                        </div>

                        <div
                          v-if="
                            requestAppointments.filter(
                              el =>
                                el.createdBy === 'admin' &&
                                el.reopened &&
                                el.used
                            ).length !== 0
                          "
                          class="d-flex flex-wrap"
                        >
                          <div class="maintenance__detail-top-col">
                            <p class="maintenance__detail-title">
                              Accepted Date and Time
                            </p>
                            <p class="maintenance__detail-item">
                              <span style="margin-right:41px">{{
                                requestAppointments.find(
                                  el =>
                                    el.createdBy === "admin" &&
                                    el.reopened &&
                                    el.used &&
                                    el.selected
                                ).date | formatDate
                              }}</span>
                              <span>{{
                                requestAppointments.find(
                                  el =>
                                    el.createdBy === "admin" &&
                                    el.reopened &&
                                    el.used &&
                                    el.selected
                                ).time | formatTimeHour
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="maintenance__detail-top-col">
                        <div
                          class="maintenance__detail-top-col"
                          style="margin-top: 20px"
                        >
                          <p class="maintenance__detail-title">
                            Artisan coming to review
                          </p>
                          <p class="maintenance__detail-item">
                            {{ request.artisanName }}
                          </p>
                        </div>
                        <div class="maintenance__detail-top-col">
                          <p class="maintenance__detail-title">
                            Artisan’s mobile number
                          </p>
                          <p class="maintenance__detail-item">
                            {{ request.artisanPhone }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- requestReopen && requestReopen.artisan -->
            <b-card no-body v-if="requestReopen && requestReopen.artisanName">
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.reopenedAccept variant="info">
                  Reopen Acceptanced
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="reopenedAccept"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div class="maintenance__detail-top mb-0">
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Assessment Date
                      </p>
                      <p class="maintenance__detail-item">
                        {{
                          requestAppointments
                            .filter(el => el.selected === true)
                            .sort(
                              (a, b) =>
                                new Date(b.createdAt) - new Date(a.createdAt)
                            )[0].date | formatDate
                        }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">Assessment Time</p>
                      <p class="maintenance__detail-item">
                        {{
                          requestAppointments
                            .filter(el => el.selected === true)
                            .sort(
                              (a, b) =>
                                new Date(b.createdAt) - new Date(a.createdAt)
                            )[0].time | formatTimeHour
                        }}
                      </p>
                    </div>
                    <div
                      class="maintenance__detail-top-col"
                      style="margin-right: 48px"
                    >
                      <p class="maintenance__detail-title">
                        Artisan coming to review
                      </p>
                      <p class="maintenance__detail-item">
                        {{ requestReopen.artisanName }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Artisan’s mobile number
                      </p>
                      <p class="maintenance__detail-item">
                        {{ requestReopen.artisanPhone }}
                      </p>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- requestReopen -->
            <b-card no-body v-if="requestReopen">
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.reopened variant="info">
                  Members Details for Reopening and Follow-up Time
                  <div
                    class="maintenance__detail-action"
                    style="margin-top: 0"
                    v-if="requestReopen && !requestReopen.artisanName"
                  >
                    <button
                      class="decline btn-reopened"
                      type="button"
                      @click="toggleDeclineModal"
                    >
                      Decline
                    </button>
                    <button
                      class="outline_btn outline_btn-green btn-reopened"
                      @click="toggleAcceptModal"
                      type="button"
                    >
                      Follow up
                    </button>
                  </div>
                  <div class="maintenance__detail-drop-icon-wrap" v-else>
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="reopened"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div
                    class="d-flex flex-wrap maintenance__detail-row"
                    style="max-width:800px; width:100%"
                  >
                    <div class="maintenance__detail-row mr-5">
                      <p class="maintenance__detail-title">
                        Reason for Reopen
                      </p>
                      <p class="maintenance__detail-item">
                        {{ requestReopen.description }}
                      </p>
                    </div>

                    <div
                      class="maintenance__detail-top-col"
                      style="margin-bottom:10px"
                    >
                      <p class="maintenance__detail-title">
                        Member’s available day and time to visit for follow-up
                      </p>
                      <p
                        class="maintenance__detail-item"
                        v-for="(appointment, index) in reopenedAppointment"
                        :key="index"
                      >
                        <span style="margin-right:41px">{{
                          appointment.date | formatDate
                        }}</span>
                        <span>{{ appointment.time | formatTimeHour }}</span>
                      </p>
                    </div>
                    <!-- <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Mobile Number
                      </p>
                      <p class="maintenance__detail-item">
                        {{ requestReopen.phone }}
                      </p>
                    </div> -->
                  </div>

                  <div
                    class="maintenance__detail-row mb-0"
                    v-if="
                      requestImages.filter(el => el.reopened === true).length >
                        0
                    "
                  >
                    <p class="maintenance__detail-title">
                      Images
                    </p>
                    <div class="d-flex flex-wrap">
                      <div
                        class="maintenance__detail-img"
                        v-for="(img, index) in requestImages.filter(
                          el => el.reopened === true
                        )"
                        :key="index"
                        :style="{
                          backgroundImage: 'url(' + img.imageUrl + ')'
                        }"
                      ></div>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
            <div class="maintenance__reopen-info" v-if="requestReopen">
              <img src="../../assets/images/reopen-info.svg" alt="info-icon" />
              <p>
                This maintenance request was reopened on
                {{ formatReopenDate(requestReopen.createdAt) }}.
              </p>
            </div>

            <!-- ratings before reopened  -->
            <b-card
              no-body
              v-if="
                requestRating &&
                  !requestReopen &&
                  (request.status === 'closed' ||
                    request.status === 'escalated') &&
                  !requestUpdates.some(update => update.afterReopen)
              "
            >
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.ratings variant="info">
                  <span>
                    Member provides rating
                  </span>
                  <div
                    class="d-flex"
                    v-if="
                      request.status === 'completed' ||
                        request.status === 'closed'
                    "
                  >
                    <span class="mr-5">
                      Request completed
                    </span>
                    <svgicon
                      icon="check-circle"
                      style="fill:transparent;stroke:#62E2AA;width:17px"
                    ></svgicon>
                  </div>
                  <div class="home__faq-icon-wrap" v-else>
                    <svgicon
                      icon="drop-down"
                      class="home__faq-icon"
                      style="stroke:#111827"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="ratings"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body style="padding-right:24px">
                  <div class="d-flex">
                    <div class="maintenance__detail-row">
                      <p class="maintenance__detail-title">Rating</p>
                      <p class="maintenance__detail-item">
                        {{
                          Number(requestRating.rating) &lt;= 2
                            ? "Poor"
                            : Number(requestRating.rating) &lt;= 4
                            ? "Good"
                            : "Delighted"
                        }}
                      </p>
                    </div>
                    <div style="width:fit-content;margin-left:90px">
                      <star-rating
                        :rating="Number(requestRating.rating)"
                        :star-size="32"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#C4C4C4"
                        :active-color="['#CE574D', '#CE574D', '#62E2AA']"
                      ></star-rating>
                    </div>
                  </div>

                  <div>
                    <p class="maintenance__detail-title">Comment</p>
                    <p class="maintenance__detail-item">
                      {{ requestRating.feedback }}
                    </p>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- !update.afterReopen -->
            <b-card
              no-body
              v-for="(update, index) in requestUpdates.filter(
                update => !update.afterReopen
              )"
              :key="index"
            >
              <b-card-header header-tag="header" role="tab">
                <b-button
                  block
                  v-b-toggle="'accordion-' + update.id"
                  variant="info"
                >
                  {{
                    update.withAppointment && update.appointmentId
                      ? "Member's Acceptance Response"
                      : update.withAppointment
                      ? `Situation Update by ${firstLetterToUpperCase(
                          update.updateBy
                        )}`
                      : (request.status === "completed" ||
                          request.status === "closed") &&
                        requestUpdates.length > 0 &&
                        index === 0
                      ? `Request completed by ${firstLetterToUpperCase(
                          update.updateBy
                        )}`
                      : `Situation Update by ${firstLetterToUpperCase(
                          update.updateBy
                        )}`
                  }}
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'accordion-' + update.id"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div v-if="update.withAppointment" style="display: flex">
                    <div
                      class="maintenance__detail-row mb-0"
                      v-if="
                        requestAppointments.filter(el => !el.used).length !==
                          0 && !update.appointmentId
                      "
                    >
                      <p class="maintenance__detail-title">
                        Follow up Date and Time
                      </p>
                      <p
                        class="maintenance__detail-item"
                        v-for="(appointment,
                        index) in requestAppointments.filter(el => !el.used)"
                        :key="index"
                      >
                        <span style="margin-right:41px">{{
                          appointment.date | formatDate
                        }}</span>
                        <span>{{ appointment.time | formatTimeHour }}</span>
                      </p>
                    </div>

                    <div v-else class="d-flex flex-wrap">
                      <div class="maintenance__detail-top-col">
                        <p class="maintenance__detail-title">
                          Follow up Date and Time
                        </p>
                        <p class="maintenance__detail-item">
                          <span style="margin-right:41px">{{
                            requestAppointments.find(
                              el => el.id === update.appointmentId
                            ).date | formatDate
                          }}</span>
                          <span>{{
                            requestAppointments.find(
                              el => el.id === update.appointmentId
                            ).time | formatTimeHour
                          }}</span>
                        </p>
                      </div>
                    </div>

                    <div
                      class="maintenance__detail-row"
                      style="margin-left:76px; margin-bottom:0"
                    >
                      <p class="maintenance__detail-title">
                        Follow Up Comment
                      </p>
                      <p class="maintenance__detail-item">
                        {{ update.description }}
                      </p>
                    </div>
                  </div>

                  <div v-else>
                    <p class="maintenance__detail-title">
                      Situation Update Comment
                    </p>
                    <p class="maintenance__detail-item">
                      {{ update.description }}
                    </p>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- Host's accepteance Response -->
            <b-card
              no-body
              v-if="
                request.status !== 'pending' &&
                  request.status !== 'pending decline' &&
                  request.status !== 'in review' &&
                  request.status !== 'declined'
              "
            >
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.assessing variant="info">
                  Host Acceptance Response
                  <div class="maintenance__detail-drop-icon-wrap">
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse
                id="assessing"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div class="maintenance__detail-top mb-0">
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Assessment Date
                      </p>
                      <p class="maintenance__detail-item">
                        {{
                          requestAppointments
                            .filter(el => el.selected === true)
                            .sort(
                              (a, b) =>
                                new Date(a.createdAt) - new Date(b.createdAt)
                            )[0].date | formatDate
                        }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">Assessment Time</p>
                      <p class="maintenance__detail-item">
                        {{
                          requestAppointments
                            .filter(el => el.selected === true)
                            .sort(
                              (a, b) =>
                                new Date(a.createdAt) - new Date(b.createdAt)
                            )[0].time | formatTimeHour
                        }}
                      </p>
                    </div>
                    <div
                      class="maintenance__detail-top-col"
                      style="margin-right: 48px"
                    >
                      <p class="maintenance__detail-title">
                        Artisan coming to review
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.artisanName }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Artisan’s mobile number
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.artisanPhone }}
                      </p>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- Request Details -->
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="info">
                  Request Details
                  <div
                    class="maintenance__detail-drop-icon-wrap"
                    v-if="request.status !== 'pending'"
                  >
                    <svgicon
                      icon="drop-down"
                      class="maintenance__detail-drop-icon"
                      style="stroke:#111827; fill:none;"
                    ></svgicon>
                  </div>
                  <button
                    v-else
                    class="outline_btn outline_btn-blue"
                    @click="toggleNudgeModal('host')"
                  >
                    Nudge Host
                  </button>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                accordion="my-accordion"
                role="tabpanel"
                visible
              >
                <b-card-body>
                  <div class="maintenance__detail-top maintenance__detail-row">
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Reason for Request
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.type | capitalize }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Space Name
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.spaceName | capitalize }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Ticket No.
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.ticketId }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Date event occurred
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.issueDate | formatDate }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Guest’s Name
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.memberFullname }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Mobile Number
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.phone }}
                      </p>
                    </div>
                    <div class="maintenance__detail-top-col">
                      <p class="maintenance__detail-title">
                        Host Name
                      </p>
                      <p class="maintenance__detail-item">
                        {{ request.hostFullname }}
                      </p>
                    </div>
                    <div
                      class="maintenance__detail-top-col"
                      style="margin-bottom:10px"
                    >
                      <p class="maintenance__detail-title">
                        Dates and Time available for a visit
                      </p>
                      <p
                        class="maintenance__detail-item"
                        v-for="(appointment, index) in initialAppointment"
                        :key="index"
                      >
                        <span style="margin-right:41px">{{
                          appointment.date | formatDate
                        }}</span>
                        <span>{{ appointment.time | formatTimeHour }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="maintenance__detail-row">
                    <p class="maintenance__detail-title">Description</p>
                    <p class="maintenance__detail-item">
                      {{ request.description }}
                    </p>
                  </div>

                  <div
                    class="maintenance__detail-row mb-0"
                    v-if="requestImages.length > 0"
                  >
                    <p class="maintenance__detail-title">
                      Images
                    </p>
                    <div class="maintenance__detail-img-wrap">
                      <div
                        class="maintenance__detail-img"
                        v-for="(img, index) in requestImages.filter(
                          el => el.reopened === false
                        )"
                        :key="index"
                        :style="{
                          backgroundImage: 'url(' + img.imageUrl + ')'
                        }"
                      ></div>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- Accept or decline button -->
            <div
              class="maintenance__detail-action"
              v-if="
                request.status === 'in review' || request.status === 'pending'
              "
            >
              <button class="decline" type="button" @click="toggleDeclineModal">
                Decline
              </button>
              <button class="accept" @click="toggleAcceptModal" type="button">
                Accept
              </button>
            </div>
          </div>
        </div>

        <!-- update log -->
        <div class="maintenance__log">
          <div
            class="maintenance__log-individual"
            v-for="(log, index) in requestUpdateLogs"
            :key="index"
          >
            <div class="maintenance__log-progress">
              <div class="maintenance__log-progress-bar"></div>

              <div class="maintenance__log-progress-mark">
                <svgicon icon="step-check"></svgicon>
              </div>
            </div>
            <div class="maintenance__log-detail">
              <p class="maintenance__log-date">
                {{ log.createdAt | formatDate }}
                {{ log.createdAt | formatTime }}
              </p>
              <p class="maintenance__log-info">{{ log.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loader" class="loader__wrap">
      <svgicon icon="spinner" class="loader"></svgicon>
    </div>

    <!-- accept request modal -->
    <AppModal
      :show="showAcceptModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleAcceptModal"
    >
      <form v-show="acceptSuccess === false" @submit.prevent="acceptRequest">
        <p class="maintenance__create-title">Accept Request</p>

        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly pick a date from the dates provided by the member</label
          >
          <div class="maintenance__create-appoint">
            <b-form-radio
              v-for="(appointment, index) in requestAppointments.length > 3
                ? requestAppointments.filter(
                    el => !el.used && el.createdBy !== 'host'
                  )
                : requestAppointments"
              :key="index"
              required
              size="lg"
              name="appointment"
              :value="appointment.id"
              v-model="appointmentId"
              class="form__check p-default p-round"
            >
              <span style="margin-right:20px;">{{
                appointment.date | formatDate
              }}</span>
              <span>{{ appointment.time | formatTimeHour }}</span>
            </b-form-radio>
          </div>
          <small v-if="appointmentIdError" class="maintenance__form-error"
            >Kindly choose a date</small
          >
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide name of artisan</label
          >
          <input
            type="text"
            required
            v-model.trim="acceptForm.artisanName"
            class="maintenance__create-input"
          />
          <small
            v-if="validation.firstError('acceptForm.artisanName')"
            class="maintenance__form-error"
            >{{ validation.firstError("acceptForm.artisanName") }}</small
          >
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide phone number of artisan</label
          >
          <input
            type="number"
            required
            v-model.trim="acceptForm.artisanPhone"
            class="maintenance__create-input"
          />
          <small
            v-if="validation.firstError('acceptForm.artisanPhone')"
            class="maintenance__form-error"
            >{{ validation.firstError("acceptForm.artisanPhone") }}</small
          >
        </div>
        <div class="maintenance__create-action">
          <span @click="toggleAcceptModal">Cancel</span>
          <button type="submit" class="cta_btn">
            <svgicon
              v-if="acceptLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </form>

      <div class="maintenance__success" v-show="acceptSuccess === true">
        <p class="maintenance__success-title">
          Request accepted
        </p>
        <p class="maintenance__success-subtitle">
          You have accepted this member’s request. Member and host have been
          notified.
        </p>
        <span class="maintenance__success-close" @click="toggleAcceptModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- decline request modal -->
    <AppModal
      :show="showDeclineModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleDeclineModal"
    >
      <div v-show="declineSuccess === false">
        <p class="maintenance__create-title">Decline Request</p>
        <p class="maintenance__create-subtitle">
          By clicking continue, you agree to not take up this member’s request.
          Member will be notified of your decline. Kindly provide a reason for
          declining this request.
        </p>
        <textarea
          class="maintenance__create-textarea"
          v-model="declineDescription"
          id=""
        ></textarea>
        <div class="maintenance__create-action">
          <span @click="toggleDeclineModal">Cancel</span>
          <button
            type="button"
            @click="declineRequest"
            class="cta_btn"
            :disabled="!declineDescription"
          >
            <svgicon
              v-if="declineloader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </div>

      <div class="maintenance__success" v-show="declineSuccess === true">
        <p class="maintenance__success-title">
          Request declined
        </p>
        <p class="maintenance__success-subtitle">
          You have declined this member’s request. Member and host have been
          notified.
        </p>
        <span class="maintenance__success-close" @click="toggleDeclineModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- reject request to decline modal -->
    <AppModal
      :show="showRejectRequestToDeclineModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleRejectRequestToDeclineModal"
    >
      <div v-show="rejectRequestToDeclineSuccess === false">
        <p class="maintenance__create-title">Host Decline Request</p>
        <p class="maintenance__create-subtitle">
          By clicking continue, you disagree to the host declining this member’s
          request. Kindly give your reason for decline
        </p>
        <textarea
          class="maintenance__create-textarea"
          v-model="rejectRequestToDeclineDescription"
          id=""
        ></textarea>
        <div class="maintenance__create-action">
          <span @click="toggleRejectRequestToDeclineModal">Cancel</span>
          <button
            type="button"
            @click="rejectRequestToDecline"
            class="cta_btn"
            :disabled="!rejectRequestToDeclineDescription"
          >
            <svgicon
              v-if="rejectRequestToDeclineLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </div>

      <div
        class="maintenance__success"
        v-show="rejectRequestToDeclineSuccess === true"
      >
        <p class="maintenance__success-title">
          Host Request declined
        </p>
        <p class="maintenance__success-subtitle">
          Host has been notified of your decline. Kindly note that you have
          declined the host’s request to reject member’s request.
        </p>
        <span
          class="maintenance__success-close"
          @click="toggleRejectRequestToDeclineModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- approve request to decline modal -->
    <AppModal
      :show="showApproveRequestToDeclineModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleApproveRequestToDeclineModal"
    >
      <div v-show="approveRequestToDeclineSuccess === false">
        <p class="maintenance__create-title">Accept Request</p>
        <p class="maintenance__create-subtitle" style="margin-bottom:61px">
          By clicking continue, you agree to the host declining this member’s
          request.
        </p>
        <div class="maintenance__create-action">
          <span @click="toggleApproveRequestToDeclineModal">Cancel</span>
          <button
            type="button"
            @click="approveRequestToDecline"
            class="cta_btn"
          >
            <svgicon
              v-if="approveRequestToDeclineLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </div>

      <div
        class="maintenance__success"
        v-show="approveRequestToDeclineSuccess === true"
      >
        <p class="maintenance__success-title">
          Member's Request declined
        </p>
        <p class="maintenance__success-subtitle">
          Member’s request has been declined.
        </p>
        <span
          class="maintenance__success-close"
          @click="toggleApproveRequestToDeclineModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- nudge host modal -->
    <AppModal
      :show="showNudgeModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleNudgeModal"
    >
      <div v-show="nudgeSuccess === false">
        <p class="maintenance__create-title">Nudge Host</p>
        <p class="maintenance__create-subtitle">
          By nudging host, you are reminding them to respond to the pending
          request on time.
        </p>
        <div class="maintenance__create-action">
          <span @click="toggleNudgeModal">Cancel</span>
          <button type="button" @click="nudge" class="cta_btn">
            <svgicon
              v-if="nudgeLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </div>

      <div class="maintenance__success" v-show="nudgeSuccess === true">
        <p class="maintenance__success-title">
          Great
        </p>
        <p class="maintenance__success-subtitle">
          You have nudged the host.
        </p>
        <span class="maintenance__success-close" @click="toggleNudgeModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- Follow up Modal -->
    <AppModal
      :show="showFollowupModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleFollowupModal"
    >
      <div v-show="followupSuccess === false">
        <p class="maintenance__create-title">Update Ticket: Follow Up</p>

        <form action="" @submit.prevent="followup">
          <div class="maintenance__create-group">
            <label for="" class="maintenance__create-label"
              >Will you be going back to visit the member?</label
            >
            <div class="maintenance__create-appoint">
              <b-form-radio
                required
                class="form__check p-default p-round"
                name="followup"
                value="yes"
                v-model="followupVisit"
                size="lg"
                ><span>Yes</span></b-form-radio
              >

              <b-form-radio
                required
                class="form__check p-default p-round"
                name="followup"
                value="not yet"
                v-model="followupVisit"
                size="lg"
                ><span>Not yet</span></b-form-radio
              >
            </div>
          </div>

          <div
            class="maintenance__create-group"
            v-if="followupVisit === 'not yet'"
          >
            <label for="" class="maintenance__create-label"
              >Kindly provide an update of the current situation</label
            >
            <textarea
              class="maintenance__create-textarea"
              v-model="followupUpdate"
              required
              id=""
            ></textarea>
          </div>

          <div class="maintenance__create-action">
            <span @click="toggleFollowupModal">Cancel</span>
            <button type="submit" class="cta_btn">
              <svgicon
                v-if="followupLoader"
                icon="spinner"
                class="loading"
              ></svgicon>
              Continue
            </button>
          </div>
        </form>
      </div>

      <div class="maintenance__success" v-show="followupSuccess === true">
        <p class="maintenance__success-title">
          Update sent!
        </p>
        <p class="maintenance__success-subtitle">
          You have updated the member. Member has been notified.
        </p>
        <span class="maintenance__success-close" @click="toggleFollowupModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- Follow up on escalation Modal -->
    <AppModal
      :show="showFollowupOnEscModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleFollowupOnEscModal"
    >
      <form
        v-show="followupOnEscSuccess === false"
        @submit.prevent="followupOnEsc"
      >
        <p class="maintenance__create-title">
          Follow Up on Escalation
        </p>
        <p class="maintenance__create-subtitle">
          Kindly provide follow up details
        </p>

        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide three certain follow up dates and time
          </label>
          <div
            class="d-flex w-100 flex-wrap"
            :style="[index === 2 ? {} : { 'margin-bottom': '8px' }]"
            v-for="(appointment, index) in newAppointmentForm.appointment"
            :key="index"
          >
            <v-date-picker
              v-model="appointment.date"
              mode="date"
              :masks="masks"
              is-required
              :popover="{ visibility: 'click' }"
              class="maintenance__create-available date"
              :min-date="new Date()"
            >
              <template v-slot="{ inputValue }">
                <div class="position-relative">
                  <input
                    disabled
                    :value="inputValue"
                    required
                    placeholder=" dd / mm / yy"
                    class="maintenance__create-input"
                  />
                  <svgicon
                    icon="calendar"
                    class="maintenance__calendar-icon"
                  ></svgicon>
                </div>
              </template>
            </v-date-picker>
            <VueTimepicker
              v-if="showFollowupOnEscModal"
              class="maintenance__create-available time"
              input-class="maintenance__create-time"
              hide-clear-button
              placeholder="00:00"
              format="hh:mm A"
              auto-scroll
              required
              v-model="appointment.time"
            >
              <template v-slot:icon>
                <img src="../../assets/images/clock.svg" />
              </template>
            </VueTimepicker>
          </div>
          <small
            v-if="verifyTimeError"
            class="maintenance__form-error text-right d-block"
            >{{ verifyTimeError }}</small
          >
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Is there anything you would like the member to know before you
            come?</label
          >
          <textarea
            class="maintenance__create-textarea"
            v-model="newAppointmentForm.comment"
            required
            id=""
          ></textarea>
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide name of artisan</label
          >
          <input
            type="text"
            required
            v-model.trim="acceptForm.artisanName"
            class="maintenance__create-input"
          />
          <small
            v-if="validation.firstError('acceptForm.artisanName')"
            class="maintenance__form-error"
            >{{ validation.firstError("acceptForm.artisanName") }}</small
          >
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide phone number of artisan</label
          >
          <input
            type="number"
            required
            v-model.trim="acceptForm.artisanPhone"
            class="maintenance__create-input"
          />
          <small
            v-if="validation.firstError('acceptForm.artisanPhone')"
            class="maintenance__form-error"
            >{{ validation.firstError("acceptForm.artisanPhone") }}</small
          >
        </div>
        <div class="maintenance__create-action">
          <span @click="toggleFollowupOnEscModal">Cancel</span>
          <button type="submit" :disabled="!fillAllOnEsc" class="cta_btn">
            <svgicon
              v-if="followupOnEscLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </form>

      <div class="maintenance__success" v-show="followupOnEscSuccess === true">
        <p class="maintenance__success-title">
          Update sent!
        </p>
        <p class="maintenance__success-subtitle">
          You have updated the member. Member has been notified.
        </p>
        <span
          class="maintenance__success-close"
          @click="toggleFollowupOnEscModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- new appointment modal -->
    <AppModal
      :show="showNewAppointmentModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleNewAppointmentModal"
    >
      <form
        v-show="newAppointmentSuccess === false"
        @submit.prevent="newAppointment"
      >
        <p class="maintenance__create-title">
          Update Ticket: Follow Up
        </p>
        <p class="maintenance__create-subtitle">
          Kindly provide follow up details
        </p>

        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide three certain follow up dates and time
          </label>
          <div
            class="d-flex w-100 flex-wrap"
            :style="[index === 2 ? {} : { 'margin-bottom': '8px' }]"
            v-for="(appointment, index) in newAppointmentForm.appointment"
            :key="index"
          >
            <v-date-picker
              v-model="appointment.date"
              mode="date"
              :masks="masks"
              is-required
              :popover="{ visibility: 'click' }"
              class="maintenance__create-available date"
              :min-date="new Date()"
            >
              <template v-slot="{ inputValue }">
                <div class="position-relative">
                  <input
                    disabled
                    :value="inputValue"
                    required
                    placeholder=" dd / mm / yy"
                    class="maintenance__create-input"
                  />
                  <svgicon
                    icon="calendar"
                    class="maintenance__calendar-icon"
                  ></svgicon>
                </div>
              </template>
            </v-date-picker>
            <VueTimepicker
              v-if="showNewAppointmentModal"
              class="maintenance__create-available time"
              input-class="maintenance__create-time"
              hide-clear-button
              placeholder="00:00"
              format="hh:mm A"
              auto-scroll
              required
              v-model="appointment.time"
            >
              <template v-slot:icon>
                <img src="../../assets/images/clock.svg" />
              </template>
            </VueTimepicker>
          </div>
          <small
            v-if="verifyTimeError"
            class="maintenance__form-error text-right d-block"
            >{{ verifyTimeError }}</small
          >
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Is there anything you would like the member to know before you
            come?</label
          >
          <textarea
            class="maintenance__create-textarea"
            v-model="newAppointmentForm.comment"
            required
            id=""
          ></textarea>
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide name of artisan</label
          >
          <input
            type="text"
            required
            v-model.trim="acceptForm.artisanName"
            class="maintenance__create-input"
          />
          <small
            v-if="validation.firstError('acceptForm.artisanName')"
            class="maintenance__form-error"
            >{{ validation.firstError("acceptForm.artisanName") }}</small
          >
        </div>
        <div class="maintenance__create-group">
          <label for="" class="maintenance__create-label"
            >Kindly provide phone number of artisan</label
          >
          <input
            type="number"
            required
            v-model.trim="acceptForm.artisanPhone"
            class="maintenance__create-input"
          />
          <small
            v-if="validation.firstError('acceptForm.artisanPhone')"
            class="maintenance__form-error"
            >{{ validation.firstError("acceptForm.artisanPhone") }}</small
          >
        </div>
        <div class="maintenance__create-action">
          <span @click="toggleNewAppointmentModal">Cancel</span>
          <button type="submit" :disabled="!fillAll" class="cta_btn">
            <svgicon
              v-if="newAppointmentLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </form>

      <div class="maintenance__success" v-show="newAppointmentSuccess === true">
        <p class="maintenance__success-title">
          Update sent!
        </p>
        <p class="maintenance__success-subtitle">
          You have updated the member. Member has been notified.
        </p>
        <span
          class="maintenance__success-close"
          @click="toggleNewAppointmentModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- comment modal -->
    <AppModal
      :show="showCommentModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleCommentModal"
    >
      <form v-show="commentSuccess === false" @submit.prevent="comment">
        <p class="maintenance__create-title" style="margin-bottom:0">
          Comment
        </p>
        <p class="maintenance__create-subtitle" style="margin-bottom:8px">
          You can send comment to the host and member or only one of them.
          Neither the host nor the member can respond to your comment.
        </p>
        <p
          class="maintenance__create-subtitle"
          style="margin-bottom:24px; color:red"
        >
          Note: Once you comment it will close this request.
        </p>

        <div class="maintenance__create-group">
          <p
            class="maintenance__create-title"
            style="font-size:16px;margin-bottom: 0"
          >
            Send a comment to host
          </p>
          <label for="" class="maintenance__create-subtitle"
            >Kindly input your comment below.
          </label>
          <textarea
            class="maintenance__create-textarea"
            v-model="hostComment"
            id=""
          ></textarea>
        </div>
        <div class="maintenance__create-group">
          <p
            class="maintenance__create-title"
            style="font-size:16px;margin-bottom: 0"
          >
            Send a comment to member
          </p>
          <label for="" class="maintenance__create-subtitle"
            >Kindly input your comment below.
          </label>
          <textarea
            class="maintenance__create-textarea"
            style="margin-bottom:40px"
            v-model="memberComment"
            id=""
          ></textarea>
        </div>
        <div class="maintenance__create-action">
          <span @click="toggleCommentModal">Cancel</span>
          <button
            type="submit"
            :disabled="!hostComment && !memberComment"
            class="cta_btn"
          >
            <svgicon
              v-if="commentLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Send Comment
          </button>
        </div>
      </form>

      <div class="maintenance__success" v-show="commentSuccess === true">
        <p class="maintenance__success-title">
          Great!
        </p>
        <p class="maintenance__success-subtitle">
          You comments have been sent.
        </p>
        <span class="maintenance__success-close" @click="toggleCommentModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- complete request modal -->
    <AppModal
      :show="showCompleteModal"
      :styleGotten="{ 'max-width': '544px', padding: '56px 24px' }"
      @onclosed="toggleCompleteModal"
    >
      <form
        @submit.prevent="completeRequest"
        v-show="completeSuccess === false"
      >
        <p class="maintenance__create-title">Complete Request</p>
        <p class="maintenance__create-subtitle">
          Kindly provide a situation update comment
        </p>
        <textarea
          class="maintenance__create-textarea"
          v-model="completeUpdate"
          required
          id=""
        ></textarea>
        <div class="maintenance__create-action">
          <span @click="toggleCompleteModal">Cancel</span>
          <button type="submit" class="cta_btn">
            <svgicon
              v-if="completeLoader"
              icon="spinner"
              class="loading"
            ></svgicon>
            Continue
          </button>
        </div>
      </form>

      <div class="maintenance__success" v-show="completeSuccess === true">
        <p class="maintenance__success-title">
          Great!
        </p>
        <p class="maintenance__success-subtitle">
          You have completed this request.
        </p>
        <span class="maintenance__success-close" @click="toggleCompleteModal"
          >Close</span
        >
      </div>
    </AppModal>

    <!-- reopen modal -->
    <AppModal
      :show="showReopenModal"
      :styleGotten="{ 'max-width': '544px', padding: '16px 24px' }"
      @onclosed="toggleReopenModal"
    >
      <div v-show="reopenSuccess === false">
        <p class="maintenance__create-title">Reopen Maintenance</p>
        <p class="maintenance__create-subtitle">
          By Reopening maintenance request, host will be notified and you will
          be contacted shortly.
        </p>
        <form class="maintenance__create" @submit.prevent="submitReopen">
          <div class="maintenance__create-group">
            <label for="" class="maintenance__create-label"
              >Kindly provide three (3) dates and time you would be available
              for a visit</label
            >
            <div
              class="d-flex w-100 flex-wrap"
              :style="[index === 2 ? {} : { 'margin-bottom': '8px' }]"
              v-for="(appointment, index) in reopened.appointment"
              :key="index"
            >
              <v-date-picker
                v-model="appointment.date"
                mode="date"
                :masks="masks"
                is-required
                :popover="{ visibility: 'click' }"
                class="maintenance__create-available date"
                :min-date="new Date()"
              >
                <template v-slot="{ inputValue }">
                  <div class="position-relative">
                    <input
                      disabled
                      :value="inputValue"
                      required
                      placeholder=" dd / mm / yy"
                      class="maintenance__create-input"
                    />
                    <svgicon
                      icon="calendar"
                      class="maintenance__calendar-icon"
                    ></svgicon>
                  </div>
                </template>
              </v-date-picker>
              <VueTimepicker
                class="maintenance__create-available time"
                input-class="maintenance__create-time"
                hide-clear-button
                placeholder="00:00"
                format="hh:mm A"
                auto-scroll
                required
                v-model="appointment.time"
              >
                <template v-slot:icon>
                  <img src="../../assets/images/clock.svg" />
                </template>
              </VueTimepicker>
            </div>
            <small
              v-if="verifyTimeError"
              class="maintenance__form-error text-right d-block"
              >{{ verifyTimeError }}</small
            >
          </div>

          <div class="maintenance__create-group">
            <label for="" class="maintenance__create-label"
              >Kindly provide reason for reopening this maintenance
              service</label
            >
            <textarea
              class="maintenance__create-textarea"
              v-model="reopened.comment"
              id=""
            ></textarea>
          </div>

          <div class="maintenance__create-group">
            <label for="" class="maintenance__create-label"
              >Kindly provide name of artisan</label
            >
            <input
              type="text"
              required
              v-model.trim="acceptForm.artisanName"
              class="maintenance__create-input"
            />
            <small
              v-if="validation.firstError('acceptForm.artisanName')"
              class="maintenance__form-error"
              >{{ validation.firstError("acceptForm.artisanName") }}</small
            >
          </div>
          <div class="maintenance__create-group">
            <label for="" class="maintenance__create-label"
              >Kindly provide phone number of artisan</label
            >
            <input
              type="number"
              required
              v-model.trim="acceptForm.artisanPhone"
              class="maintenance__create-input"
            />
            <small
              v-if="validation.firstError('acceptForm.artisanPhone')"
              class="maintenance__form-error"
              >{{ validation.firstError("acceptForm.artisanPhone") }}</small
            >
          </div>

          <div class="maintenance__create-action">
            <span @click="toggleReopenModal">Cancel</span>
            <button type="submit" :disabled="!fillAllReopen" class="cta_btn">
              <svgicon
                v-if="reopenLoader"
                icon="spinner"
                class="loading"
              ></svgicon>
              Reopen Request
            </button>
          </div>
        </form>
      </div>

      <div
        class="maintenance__success"
        style="margin:20px 0"
        v-show="reopenSuccess === true"
      >
        <!-- <img
          src="../../assets/illustration/success.svg"
          class="img-fluid"
          alt="success"
        /> -->
        <p class="maintenance__success-title">
          Thank you! Your request has been sent.
        </p>
        <p class="maintenance__success-subtitle" style="max-width:100%">
          You have reopened a maintenance request.
        </p>
        <span
          class="maintenance__success-close"
          style="margin-bottom:0"
          @click="toggleReopenModal"
          >Close</span
        >
      </div>
    </AppModal>
  </div>
</template>

<script>
import {
  getRequestDetail,
  declineRequest,
  rejectRequestToDecline,
  approveRequestToDecline,
  acceptRequest,
  followup,
  followupOnEsc,
  newAppointment,
  completeRequest,
  nudgeMember,
  nudgeHost,
  comment,
  reopened
} from "../../../services/maintenance";
import { mixin as clickaway } from "vue-clickaway";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import TrackerModal from "../resuables/progress.vue";
import StarRating from "vue-star-rating";

export default {
  name: "maintenanceDetail",
  mixins: [clickaway],
  components: {
    VueTimepicker,
    TrackerModal,
    StarRating
  },
  data() {
    return {
      request: null,
      requestImages: [],
      requestAppointments: [],
      requestUpdateLogs: [],
      requestUpdates: [],
      requestReopen: null,
      requestRating: null,
      appointmentDate: false,
      requestEscalates: [],

      showFollowupAction: false,
      followupAction: "",
      numberOfFollowUps: 0,

      loader: false,

      declineSuccess: false,
      showDeclineModal: false,
      declineDescription: null,
      declineloader: false,

      rejectRequestToDeclineSuccess: false,
      showRejectRequestToDeclineModal: false,
      rejectRequestToDeclineDescription: null,
      rejectRequestToDeclineLoader: false,

      approveRequestToDeclineSuccess: false,
      showApproveRequestToDeclineModal: false,
      approveRequestToDeclineDescription: null,
      approveRequestToDeclineLoader: false,

      nudgeLoader: false,
      nudgeSuccess: false,
      showNudgeModal: false,
      nudgeWho: null,
      nudgeAdminDescription: "",
      showTracker: false,

      followupSuccess: false,
      showFollowupModal: false,
      followupUpdate: "",
      followupLoader: false,
      followupVisit: null,

      followupOnEscSuccess: false,
      showFollowupOnEscModal: false,
      followupOnEscLoader: false,

      commentSuccess: false,
      showCommentModal: false,
      commentLoader: false,
      hostComment: "",
      memberComment: "",

      newAppointmentSuccess: false,
      showNewAppointmentModal: false,
      newAppointmentForm: {
        appointment: [
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          }
        ],
        comment: null
      },
      newAppointmentLoader: false,

      acceptLoader: false,
      acceptSuccess: false,
      showAcceptModal: false,

      appointmentId: null,
      appointmentIdError: false,

      acceptForm: {
        artisanPhone: null,
        artisanName: null
      },

      completeLoader: false,
      completeSuccess: false,
      showCompleteModal: false,
      completeUpdate: null,

      reopened: {
        appointment: [
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          }
        ],
        comment: null
      },
      reopenLoader: false,
      reopenSuccess: false,
      showReopenModal: false,

      isTimeEmpty: null,
      verifyTimeError: null,

      updateDropdown: false,
      masks: {
        input: "DD / MMM / YYYY"
      }
    };
  },
  methods: {
    updateTicket() {
      if (this.followupVisit === "not yet") {
        this.followup();
      } else {
        this.toggleFollowupModal();
        this.toggleNewAppointmentModal();
      }
    },
    toggleTracker() {
      this.showTracker = false;
    },
    toggleFollowupActionModal() {
      this.showFollowupAction = !this.showFollowupAction;
      this.followupAction = "";
    },
    checkFollowupAction() {
      const actionSelected = this.followupAction;
      this.toggleFollowupActionModal();
      if (actionSelected == "followup") {
        this.toggleFollowupModal();
      } else if (actionSelected == "complete") {
        this.toggleCompleteModal();
      }
    },
    toggleNudgeModal(who) {
      this.showNudgeModal = !this.showNudgeModal;
      this.nudgeSuccess = false;
      this.nudgeWho = who;
    },
    toggleFollowupModal() {
      this.showFollowupModal = !this.showFollowupModal;
      this.followupSuccess = false;
      this.followupUpdate = "";
      this.followupVisit = null;
      this.page1 = true;
      this.page2 = false;
      this.updateDropdown = false;
    },
    toggleNewAppointmentModal() {
      this.showNewAppointmentModal = !this.showNewAppointmentModal;
      this.newAppointmentForm = {
        appointment: [
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          }
        ],
        comment: null,
        artisanName: null,
        artisanPhone: null
      };
      this.newAppointmentSuccess = false;
    },
    toggleFollowupOnEscModal() {
      this.showFollowupOnEscModal = !this.showFollowupOnEscModal;
      this.newAppointmentForm = {
        appointment: [
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          }
        ],
        comment: null
      };
      (this.acceptForm = {
        artisanPhone: null,
        artisanName: null
      }),
        (this.followupOnEscSuccess = false);
    },

    toggleDeclineModal() {
      this.showDeclineModal = !this.showDeclineModal;
      this.declineSuccess = false;
      this.declineDescription = null;
    },
    toggleRejectRequestToDeclineModal() {
      this.showRejectRequestToDeclineModal = !this
        .showRejectRequestToDeclineModal;
      this.rejectRequestToDeclineSuccess = false;
      this.rejectRequestToDeclineDescription = null;
    },
    toggleApproveRequestToDeclineModal() {
      this.showApproveRequestToDeclineModal = !this
        .showApproveRequestToDeclineModal;
      this.approveRequestToDeclineSuccess = false;
      this.approveRequestToDeclineDescription = null;
    },
    toggleAcceptModal() {
      this.showAcceptModal = !this.showAcceptModal;
      if (this.showAcceptModal) {
        this.appointmentDate = true;
      } else {
        this.appointmentDate = false;
      }
      this.acceptSuccess = false;
      this.acceptForm = {
        artisanPhone: null,
        artisanName: null
      };
    },
    toggleCompleteModal() {
      this.updateDropdown = false;
      this.showCompleteModal = !this.showCompleteModal;
      this.completeSuccess = false;
      this.completeUpdate = null;
    },
    toggleCommentModal() {
      this.showCommentModal = !this.showCommentModal;
      this.commentSuccess = false;
      this.hostComment = "";
      this.memberComment = "";
    },
    toggleReopenModal() {
      this.showReopenModal = !this.showReopenModal;
      this.reopenSuccess = false;
      this.reopened = {
        appointment: [
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          },
          {
            date: "",
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          }
        ],
        comment: null
      };
      this.acceptForm = {
        artisanPhone: null,
        artisanName: null
      };
    },
    submitReopen() {
      if (this.isTimeEmpty) {
        this.verifyTimeError = "Kindly fill in all the time fields";
      } else {
        this.reopenLoader = true;
        const payload = {
          appointment: this.reopened.appointment.map(el => {
            return {
              date: moment(el.date).format("YYYY-MM-DD"),
              time: moment(
                `${el.time.hh}:${el.time.mm} ${el.time.A}`,
                "hh:mm A"
              ).format("HH:mm")
            };
          }),
          comment: this.reopened.comment,
          ...this.acceptForm
        };
        reopened(this.$route.params.id, payload)
          .then(res => {
            this.reopenLoader = false;
            this.reopenSuccess = true;
            this.getRequestDetail(this.$route.params.id);
          })
          .catch(err => {
            this.reopenLoader = false;
            this.$notification.error({
              message: "Reopen Error",
              description: err.response.data.message,
              style: {
                "z-index": 9999
              }
            });
          });
      }
    },
    getRequestDetail(id) {
      this.loader = true;
      getRequestDetail(id)
        .then(res => {
          this.loader = false;
          this.request = res.data.data.maintenanceRequest;
          this.requestImages = res.data.data.maintenanceImages;
          this.requestAppointments =
            res.data.data.maintenanceRequestAppointments;
          this.requestUpdateLogs = res.data.data.maintenanceUpdateLogs;
          this.requestUpdates = res.data.data.maintenanceUpdates;
          this.request = res.data.data.maintenanceRequest;
          this.requestReopen = res.data.data.maintenanceReopen;
          this.requestRating = res.data.data.maintenanceRating;
          this.numberOfFollowUps = res.data.data.numberOfFollowUps;
          this.requestEscalates = res.data.data.maintenanceEscalates;
        })
        .catch(err => {
          this.loader = false;
        });
    },
    declineRequest() {
      this.declineloader = true;
      const payload = {
        declineReason: this.declineDescription
      };
      declineRequest(this.$route.params.id, payload)
        .then(res => {
          this.declineloader = false;
          this.declineSuccess = true;
          this.getRequestDetail(this.$route.params.id);
        })
        .catch(err => {
          this.declineloader = false;
          this.toggleDeclineModal();
          this.$notification.error({
            message: "Decline Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    acceptRequest() {
      this.acceptLoader = true;
      if (this.appointmentId) {
        this.appointmentIdError = false;
        const payload = {
          ...this.acceptForm,
          appointmentId: this.appointmentId
        };
        this.$validate().then(success => {
          if (success) {
            this.acceptLoader = true;
            acceptRequest(this.$route.params.id, payload)
              .then(res => {
                this.acceptLoader = false;
                this.acceptSuccess = true;
                this.getRequestDetail(this.$route.params.id);
              })
              .catch(err => {
                this.acceptLoader = false;
                this.toggleAcceptModal();
                this.$notification.error({
                  message: "Accept Error",
                  description: err.response.data.message,
                  style: {
                    "z-index": 9999
                  }
                });
                return err;
              });
          }
        });
      } else {
        this.appointmentIdError = true;
      }
    },
    rejectRequestToDecline() {
      this.rejectRequestToDeclineLoader = true;
      const payload = {
        reason: this.rejectRequestToDeclineDescription
      };
      rejectRequestToDecline(this.$route.params.id, payload)
        .then(res => {
          this.rejectRequestToDeclineLoader = false;
          this.rejectRequestToDeclineSuccess = true;
          this.getRequestDetail(this.$route.params.id);
        })
        .catch(err => {
          this.rejectRequestToDeclineLoader = false;
          this.$notification.error({
            message: "Decline Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    approveRequestToDecline() {
      this.approveRequestToDeclineLoader = true;
      approveRequestToDecline(this.$route.params.id)
        .then(res => {
          this.approveRequestToDeclineLoader = false;
          this.approveRequestToDeclineSuccess = true;
          this.getRequestDetail(this.$route.params.id);
        })
        .catch(err => {
          this.approveRequestToDeclineLoader = false;
          this.$notification.error({
            message: "Decline Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    followup() {
      if (this.followupVisit === "not yet") {
        this.followupLoader = true;
        const payload = {
          description: this.followupUpdate
        };
        followup(this.$route.params.id, payload)
          .then(res => {
            this.followupLoader = false;
            this.followupSuccess = true;
            this.getRequestDetail(this.$route.params.id);
          })
          .catch(err => {
            this.followupLoader = false;
            this.$notification.error({
              message: "Follow up Error",
              description: err.response.data.message,
              style: {
                "z-index": 9999
              }
            });
          });
      } else if (this.followupVisit === "yes") {
        this.showNewAppointmentModal = true;
        this.toggleFollowupModal();
      }
    },
    newAppointment() {
      if (this.isTimeEmpty) {
        this.verifyTimeError = "Kindly fill in all the time fields";
      } else {
        this.newAppointmentLoader = true;
        this.verifyTimeError = null;
        const payload = {
          comment: this.newAppointmentForm.comment,
          ...this.acceptForm,
          appointment: this.newAppointmentForm.appointment.map(el => {
            return {
              date: moment(el.date).format("YYYY-MM-DD"),
              time: moment(
                `${el.time.hh}:${el.time.mm} ${el.time.A}`,
                "hh:mm A"
              ).format("HH:mm")
            };
          })
        };
        delete payload.appointmentId;
        this.$validate().then(success => {
          if (success) {
            newAppointment(this.$route.params.id, payload)
              .then(res => {
                this.newAppointmentLoader = false;
                this.newAppointmentSuccess = true;
                this.getRequestDetail(this.$route.params.id);
              })
              .catch(err => {
                this.newAppointmentLoader = false;
                this.$notification.error({
                  message: "Follow up Error",
                  description: err.response.data.message,
                  style: {
                    "z-index": 9999
                  }
                });
              });
          } else {
            this.newAppointmentLoader = false;
          }
        });
      }
    },
    followupOnEsc() {
      if (this.isTimeEmpty) {
        this.verifyTimeError = "Kindly fill in all the time fields";
      } else {
        this.followupOnEscLoader = true;
        this.verifyTimeError = null;
        const payload = {
          comment: this.newAppointmentForm.comment,
          ...this.acceptForm,
          appointment: this.newAppointmentForm.appointment.map(el => {
            return {
              date: moment(el.date).format("YYYY-MM-DD"),
              time: moment(
                `${el.time.hh}:${el.time.mm} ${el.time.A}`,
                "hh:mm A"
              ).format("HH:mm")
            };
          })
        };
        delete payload.appointmentId;
        this.$validate().then(success => {
          if (success) {
            followupOnEsc(this.$route.params.id, payload)
              .then(res => {
                this.followupOnEscLoader = false;
                this.followupOnEscSuccess = true;
                this.getRequestDetail(this.$route.params.id);
              })
              .catch(err => {
                this.followupOnEscLoader = false;
                this.$notification.error({
                  message: "Follow up Error",
                  description: err.response.data.message,
                  style: {
                    "z-index": 9999
                  }
                });
              });
          } else {
            this.newAppointmentLoader = false;
          }
        });
      }
    },
    completeRequest() {
      this.completeLoader = true;
      const payload = {
        description: this.completeUpdate
      };
      completeRequest(this.$route.params.id, payload)
        .then(res => {
          this.completeLoader = false;
          this.completeSuccess = true;
          this.getRequestDetail(this.$route.params.id);
        })
        .catch(err => {
          this.completeLoader = false;
          this.$notification.error({
            message: "Complete Error",
            description: err.response.data.message,
            style: {
              "z-index": 9999
            }
          });
        });
    },
    formatReopenDate(date) {
      return moment(date).format("dddd MMM DD, YYYY");
    },
    nudge() {
      this.nudgeLoader = true;
      if (this.nudgeWho === "member") {
        nudgeMember(this.$route.params.id)
          .then(res => {
            this.nudgeLoader = false;
            this.nudgeSuccess = true;
            this.getRequestDetail(this.$route.params.id);
          })
          .catch(err => {
            this.nudgeLoader = false;
            this.toggleNudgeModal();
            this.$notification.error({
              message: "Nudge Error",
              description: err.response.data.message,
              style: {
                "z-index": 9999
              }
            });
          });
      } else if (this.nudgeWho === "host") {
        nudgeHost(this.$route.params.id)
          .then(res => {
            this.nudgeLoader = false;
            this.nudgeSuccess = true;
            this.getRequestDetail(this.$route.params.id);
          })
          .catch(err => {
            this.nudgeLoader = false;
            this.toggleNudgeModal();
            this.$notification.error({
              message: "Nudge Error",
              description: err.response.data.message,
              style: {
                "z-index": 9999
              }
            });
          });
      }
    },
    comment() {
      this.commentLoader = true;
      const payload = {
        hostComment: this.hostComment,
        memberComment: this.memberComment
      };
      comment(this.$route.params.id, payload)
        .then(res => {
          this.commentLoader = false;
          this.commentSuccess = true;
          this.getRequestDetail(this.$route.params.id);
        })
        .catch(err => {
          this.commentLoader = false;
          this.$notification.error({
            message: "Follow up Error",
            description: err.response.data.message,
            style: {
              "z-index": 9999
            }
          });
        });
    },
    statusStyle(status) {
      return [
        { completed: status == "completed" },
        { pending: status == "pending" },
        { review: status == "in review" },
        { assessing: status == "assessing" },
        { follow: status == "follow up" },
        { declined: status == "declined" },
        { contested: status == "contested" },
        { closed: status == "closed" },
        { reopened: status == "reopened" },
        { escalated: status == "escalated" },
        { pendingDecline: status == "pending decline" }
      ];
    },
    firstLetterToUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  mounted() {
    // this.getRequestDetail(this.$route.pa.id);
  },

  created() {
    this.getRequestDetail(this.$route.params.id);
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage() {
      return this.$route.query.currentPage || 1;
    },
    validateFollowupUpdate() {
      if (this.followupVisit !== null) {
        if (this.followupVisit === "yes") {
          return false;
        } else if (
          this.followupVisit !== "yes" &&
          this.followupUpdate.length > 0
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    fillAll() {
      if (this.newAppointmentForm.comment) {
        if (
          this.newAppointmentForm.appointment[0].date &&
          this.newAppointmentForm.appointment[0].time
        ) {
          if (
            this.newAppointmentForm.appointment[1].date &&
            this.newAppointmentForm.appointment[1].time
          ) {
            if (
              this.newAppointmentForm.appointment[2].date &&
              this.newAppointmentForm.appointment[2].time
            ) {
              return true;
            }
          }
        }
      } else if (!this.newAppointmentForm.comment) {
        if (
          !this.newAppointmentForm.appointment[0].date &&
          !this.newAppointmentForm.appointment[0].time
        ) {
          if (
            !this.newAppointmentForm.appointment[1].date &&
            !this.newAppointmentForm.appointment[1].time
          ) {
            if (
              !this.newAppointmentForm.appointment[2].date &&
              !this.newAppointmentForm.appointment[2].time
            ) {
              return false;
            }
          }
        }
      }
      return false;
    },
    fillAllOnEsc() {
      if (this.newAppointmentForm.comment) {
        if (
          this.newAppointmentForm.appointment[0].date &&
          this.newAppointmentForm.appointment[0].time
        ) {
          if (
            this.newAppointmentForm.appointment[1].date &&
            this.newAppointmentForm.appointment[1].time
          ) {
            if (
              this.newAppointmentForm.appointment[2].date &&
              this.newAppointmentForm.appointment[2].time
            ) {
              if (this.acceptForm.artisanPhone) {
                if (this.acceptForm.artisanName) {
                  return true;
                }
              }
            }
          }
        }
      } else if (!this.newAppointmentForm.comment) {
        if (
          !this.newAppointmentForm.appointment[0].date &&
          !this.newAppointmentForm.appointment[0].time
        ) {
          if (
            !this.newAppointmentForm.appointment[1].date &&
            !this.newAppointmentForm.appointment[1].time
          ) {
            if (
              !this.newAppointmentForm.appointment[2].date &&
              !this.newAppointmentForm.appointment[2].time
            ) {
              if (!this.acceptForm.artisanPhone) {
                if (!this.acceptForm.artisanName) {
                  return false;
                }
              }
            }
          }
        }
      }
      return false;
    },
    fillAllReopen() {
      if (
        this.reopened.appointment[0].date &&
        this.reopened.appointment[0].time
      ) {
        if (
          this.reopened.appointment[1].date &&
          this.reopened.appointment[1].time
        ) {
          if (
            this.reopened.appointment[2].date &&
            this.reopened.appointment[2].time
          ) {
            if (this.reopened.comment) {
              if (this.acceptForm.artisanPhone) {
                if (this.acceptForm.artisanName) {
                  return true;
                }
              }
            }
          }
        }
      } else if (
        !this.reopened.appointment[0].date &&
        !this.reopened.appointment[0].time
      ) {
        if (
          !this.reopened.appointment[1].date &&
          !this.reopened.appointment[1].time
        ) {
          if (
            !this.reopened.appointment[2].date &&
            !this.reopened.appointment[2].time
          ) {
            if (!this.reopened.comment) {
              if (!this.acceptForm.artisanPhone) {
                if (!this.acceptForm.artisanName) {
                  return false;
                }
              }
            }
          }
        }
      }
      return false;
    },
    initialAppointment() {
      if (this.requestAppointments && this.requestAppointments.length > 3) {
        let initial = this.requestAppointments
          .filter(el => el.used && el.createdBy !== "host")
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        if (initial.length > 3) {
          return initial.slice(3);
        } else {
          return initial;
        }
      } else {
        return this.requestAppointments;
      }
    },
    reopenedAppointment() {
      if (this.requestAppointments && this.requestAppointments.length > 3) {
        let initial = this.requestAppointments.filter(
          el => !el.used && el.createdBy !== "host"
        );
        if (initial.length === 0) {
          let newInitial = this.requestAppointments
            .filter(el => el.used && el.createdBy !== "host")
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, 3);
          return newInitial;
        } else {
          return initial;
        }
      } else {
        return [];
      }
    },
    appointments() {
      return this.newAppointmentForm.appointment;
    }
  },
  watch: {
    appointments: {
      handler(val) {
        let allTime = [];
        val.forEach((el, index) => {
          for (const key in el.time) {
            allTime.push({ [key + index]: el.time[key] });
          }
        });
        this.isTimeEmpty = allTime.some(time => {
          for (const key in time) {
            if (time[key] === "") {
              return true;
            } else {
              return false;
            }
          }
        });
      },
      deep: true
    }
  },
  validators: {
    "acceptForm.artisanPhone": function(value) {
      return this.$Validator
        .value(value)
        .required()
        .digit()
        .maxLength(13, "Phone number cannot be more than 13 digits")
        .minLength(7);
    },
    "acceptForm.artisanName": function(value) {
      return this.$Validator
        .value(value)
        .required()
        .regex("^[A-Za-z ]*$", "Must only contain alphabetic characters.");
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/maintenanceDetail.vue